<div
    role="group"
    class="volume-horaire-input-container"
    [formGroup]="parts"
    [attr.aria-labelledby]="_formField.getLabelId()"
    (focusin)="onFocusIn()"
    (focusout)="onFocusOut($event)"
>
    <input
        data-tfa="volume-horaire-input_heures"
        class="volume-horaire-input-element heures"
        matInput
        formControlName="heures"
        size="4"
        maxLength="4"
        aria-label="heures code"
        (input)="_handleInput(parts.controls.heures, minutes)"
        #heures
    />
    <span class="volume-horaire-input-spacer">h</span>

    <input
        data-tfa="volume-horaire-input_minutes"
        class="volume-horaire-input-element minutes"
        matInput
        formControlName="minutes"
        maxLength="2"
        size="2"
        aria-label="minutes number"
        (input)="_handleInput(parts.controls.minutes)"
        (keyup.backspace)="autoFocusPrev(parts.controls.minutes, heures)"
        #minutes
    />
</div>
